import request from 'api/request';

export default function accountUserIndexRoute() {
  return request({ url: '/account/users' });
}
